<template>
  <Modal
    :modal="modal"
    title="Selecione o Produto"
    cardBodyClass="pa-0"
    @close="$emit('close')"
    @save="save"
    @refresh="getProdutosAPI"
    @search="searchBox = !searchBox"
    :loading="loading"
    :fullscreen="true"
    :titleIcons="titleIcons"
  >
    <ListProdutosSelect
      :searchBox="searchBox"
      :tabelaPreco="tabelaPreco"
      @produtoSelected="produtoSelected = $event"
    />
  </Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Modal from '@/components/shared/Modal';
import ListProdutosSelect from '@/components/produtos/ListProdutosSelect';

export default {
  name: 'ModalProdutoSelect',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    tabelaPreco: {
      type: Object,
      default: null
    }
  },
  components: {
    Modal,
    ListProdutosSelect,
  },
  data() {
    return {
      page: 1,
      order: 'descricao',
      loading: false,
      searchBox: false,
      produtoSelected: null,
    }
  },
  computed: {
    ...mapGetters(['produtos']),
    titleIcons() {
      return [
        { name: 'mdi-refresh', event: 'refresh', loading: true },
        { name: this.searchBox ? 'mdi-close' : 'mdi-magnify', event: 'search', loading: false },
      ]
    }
  },
  methods: {
    ...mapMutations(['SHOW_SNACKBAR']),
    ...mapActions(['fetchProdutos', 'fetchProdutosAPI', 'createProduto']),
    getProdutos() {
      this.loading = true;
        this.fetchProdutos()
          .then(() => this.loading = false);
    },
    getProdutosAPI() {
      this.loading = true;
        this.fetchProdutosAPI()
          .then(() => this.loading = false);
    },
    save() {
      if (this.produtoSelected) {
        this.$emit('save', this.produtoSelected);
      } else {
        this.SHOW_SNACKBAR({ text: 'Selecione o produto!', status: 'error' });
      }
    }
  },
  watch: {
    modal(value) {
      if (value && !this.produtos.length && !this.loading) {
        this.getProdutos();
      }
    },
  },
}
</script>

<style>

</style>